export const REQUEST_TIME_SLOTS = 'REQUEST_TIME_SLOTS';
export const REQUEST_TIME_SLOTS_SUCCESS = 'REQUEST_TIME_SLOTS_SUCCESS';
export const REQUEST_TIME_SLOTS_ERROR = 'REQUEST_TIME_SLOTS_ERROR';


export const UPDATE_SCHEDULE_SLOT = 'UPDATE_SCHEDULE_SLOT';
export const UPDATE_SCHEDULE_SLOT_SUCCESS = 'UPDATE_SCHEDULE_SLOT_SUCCESS';
export const UPDATE_SCHEDULE_SLOT_ERROR = 'UPDATE_SCHEDULE_SLOT_ERROR';